import { WidgetSettings } from '@/components/WidgetSettings';

export function WidgetTab({ hotelId, hotelName }) {
  return (
    <div className="space-y-6" data-testid="owner-widget-content">
      <div>
        <h2 className="text-2xl font-bold heading-font mb-2">Booking Widget</h2>
        <p className="text-muted-foreground">Customize and embed the booking widget on your website</p>
      </div>
      
      <WidgetSettings hotelId={hotelId} hotelName={hotelName} />
    </div>
  );
}
